module.exports = __webpack_public_path__ + "static/media/3-10.6a59ebbb.mp3";